export default "__VITE_ASSET__CnMH3Hz3__"